import React from 'react';

type Props = {
  strokeColor?: string;
} & typeof defaultProps;

const defaultProps = {
  strokeColor: '#424B50',
};

const DocumentParentIcon = function DocumentParentIcon({ strokeColor }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
      <path d="M1 0V5.5C1 6.60457 1.89543 7.5 3 7.5H8.5" stroke={strokeColor} strokeWidth="0.6" />
    </svg>
  );
};

DocumentParentIcon.defaultProps = defaultProps;
export default DocumentParentIcon;
